var redefine = require('./$.redefine');
module.exports = function(target, src){
  for(var key in src)redefine(target, key, src[key]);
  return target;
};


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6682bo/master/~/vue2-google-maps/~/core-js/library/modules/$.redefine-all.js
// module id = 299
// module chunks = 1